import { PropertyEmailLookupModelDto } from './../../models/lookup/property.lookup-email.model';
import { CommonObjectModel, IGenericObject } from '../../models/common/index';
import { IBaseState } from '..';
import { LookupServices } from '../../services';
import { ILookupPropertyEnvironment } from '../../models/lookup/property.environment.model';
import { ICondition } from '../../models/lookup/condition.model';
import { IConstruction } from '../../models/lookup/construction.model';
import { IExteriorComfort } from '../../models/lookup/exterior-comfort.model';
import { IGoal } from '../../models/lookup/goal.model';
import { IHeating } from '../../models/lookup/heating.model';
import { IHeatingB } from '../../models/lookup/heatingB.model';
import { IInteriorComfort } from '../../models/lookup/interior-comfort.model';
import { IKitchen } from '../../models/lookup/kitchen.model';
import { IRearOrientation } from '../../models/lookup/rear-orientation.model';
import { IRoofMaterial } from '../../models/lookup/roof-material.model';
import { IRoof } from '../../models/lookup/roof.model';
import { IStyle } from '../../models/lookup/style.model';
import { IRoofCondition } from '../../models/lookup/roof-condition.model';
import { IWindowsGlazing } from '../../models/lookup/windows-glazing.model';
import { IWindowFrame } from '../../models/lookup/window-frame.model';
import { IAppointmentTypeListing } from '../../models/agenda/appointment-type-listing.model';
import { IAppointmentStatus } from '../../models/agenda/appointment-status.model';
import { ISourceContact } from '../../models/lookup/sourcecontact.model';

export interface ILookupState extends IBaseState<LookupServices, {}> {
  	listOfAsbestosType?: IGenericObject[];
	//#region WE CAN STORE EVERYTHING IN ONE OBJECT
	storedlookupObject?: Object;
	//#region WE CAN STORE COLOR IN ONE OBJECT
	storedlookupColor?: Object;
	//#endregion

	listOfDemandPurposes?: CommonObjectModel[];
	listOfDemandStatus?: CommonObjectModel[];
	listOfCommonGoals?: CommonObjectModel[];
	listOfCommonManagers?: CommonObjectModel[];
	listOfMonth?: IGenericObject[];

	listOfEmailByPropertyIds?: PropertyEmailLookupModelDto[];
	listOfAddressTitles?: CommonObjectModel[];
	listOfC21Professions?: CommonObjectModel[];
	listOfCategories?: CommonObjectModel[];
	listOfDepartments?: CommonObjectModel[];
	listOfDurationTasks?: CommonObjectModel[];
	listOfCities?: CommonObjectModel[];
	listOfCities1?: CommonObjectModel[];
	listOfCities2?: CommonObjectModel[];
	listOfCities3?: CommonObjectModel[];
	listOfCountries?: CommonObjectModel[];
	listOfCountries1?: CommonObjectModel[];
	listOfCountries2?: CommonObjectModel[];
	listOfCountries3?: CommonObjectModel[];
	listOfGoals?: IGenericObject[];
	listOfLetterTitles?: CommonObjectModel[];
	listOfMaritalStatuses?: CommonObjectModel[];
	listOfPersonDemands?: CommonObjectModel[];
	listOfPersonFunctions?: CommonObjectModel[];
	listOfPersonProperties?: CommonObjectModel[];
	listOfPersonProposals?: CommonObjectModel[];
	listOfPersonSources?: CommonObjectModel[];
	listOfPersonTypes?: CommonObjectModel[];
	listOfPhoneDescriptions?: CommonObjectModel[];
	listOfPreConfirmations?: CommonObjectModel[];
	listOfPreferredMedia?: CommonObjectModel[];
	listOfPurposes?: IGenericObject[];
	listOfRelationTypes?: CommonObjectModel[];
	listOfRelationReverseTypes?: CommonObjectModel[];
	listOfStatus?: IGenericObject[];
	listOfStatuses?: IGenericObject[];
	listOfSites?: IGenericObject[];
	listOfSinceDate?: IGenericObject[];
	listOfTaskTypes?: CommonObjectModel[];
	listOfTaskGroups?: CommonObjectModel[];
	listTypesOfProperty?: IGenericObject[];
	listOfDocumentTypes?: IGenericObject[];
	listOfDocumentPublish?: IGenericObject[];
	listOfPictureGroups?: IGenericObject[];
	listOfRoomStates?: IGenericObject[];
	listOfRoomDescriptions?: IGenericObject[];
	listOfRoomCovering?: IGenericObject[];
	listOfRoomFloors?: IGenericObject[];
	listOfRoomKeywords?: IGenericObject[];
	listOfOrientations?: IGenericObject[];
	listOfHasSummon?:IGenericObject[];

	listOfCO2Emission?: IGenericObject[];
	listOfInsulation?: IGenericObject[];
	listOfEPCLuxembourg?: IGenericObject[];
	listOfEPCFlanders?: IGenericObject[];
	listOfEPCImmoWeb?: IGenericObject[];
	listOfEPCType?: IGenericObject[];
	listOfEPCNR?: IGenericObject[];
	listOfEPCkNR?: IGenericObject[];
	listOfEPCBrussels?: IGenericObject[];
	listOfGroundCertificate?: IGenericObject[];
	listOfOilTankPlacement?: IGenericObject[];
	listOfOilTankFurtherExploitation?: IGenericObject[];
	listOfOilTankCertificateOfInspection?: IGenericObject[];
	listOfElectricityImmoWeb?: IGenericObject[];
	listOfGasolineImmoWeb?: IGenericObject[];
	listOfPermitOptions?: IGenericObject[];
	listOfAreaApplication?: IGenericObject[];
	listOfHeritageType?: IGenericObject[];
	listOfFloodRisk?: IGenericObject[];
	listOfFloodZoneType?: IGenericObject[];
	listOfYesNo?: IGenericObject[];
	listOfCompanies?: IGenericObject[];
	listOfManWoman?: IGenericObject[];
	listOfViagerType?: IGenericObject[];
	listOfRegisteredTypeFlanders?: IGenericObject[];
	listOfRegisteredTypeWallonia?: IGenericObject[];
	listOfRegisteredTypeBrussels?: IGenericObject[];
	listOfRegisteredTypeNone?: IGenericObject[];
	listOfPublicUtilities?: IGenericObject[];
	listOfChargeElements?: IGenericObject[];
	listOfPropertyEnvironment?: ILookupPropertyEnvironment[];
	//
	listOfCondition?: ICondition[]
	listOfConstruction?: IConstruction[]
	listOfExteriorComfort?: IExteriorComfort[]
	listOfGoal?: IGoal[]
	listOfHeating?: IHeating[]
	listOfHeatingB?: IHeatingB[]
	listOfInteriorComfort?: IInteriorComfort[]
	listOfKitchen?: IKitchen[]
	listOfRearOrientation?: IRearOrientation[]
	listOfRoofMaterial?: IRoofMaterial[]
	listOfRoof?: IRoof[]
	listOfStyle?: IStyle[]
	listOfRoofCondition?: IRoofCondition[];
	listOfWindowsGlazing?: IWindowsGlazing[];
	listOfWindowFrame?: IWindowFrame[];
	listOfImmoWebOption?: CommonObjectModel[];
	ListOfPublishOnMedia?: CommonObjectModel[];
	ListOfFinanceReduction?: CommonObjectModel[];
	listOfSourceContact?: ISourceContact[];
	listOfCanceledReason?: ISourceContact[];
	//#region property-relation

	listOfMandateType?: IGenericObject[];
	listOfProlongationType?: IGenericObject[];
	listOfCommissionType?: IGenericObject[];
	listOfDepositType?: IGenericObject[];
	listOfPersonType?: IGenericObject[];
	listOfConfirmEmailTime?: IGenericObject[];
	listOfParticularConditionClause?: IGenericObject[];
	listOfPrePaymentType?: IGenericObject[];
	//#endregion

	listOfAppointmentTypes?: IAppointmentTypeListing[];
	listOfAppointmentStatus?: IAppointmentStatus[];
	listOfPersonalByAgendaId?: any[];
    listOfCandidates?: any[];

    listPersonSites?: IGenericObject[];
    listPropertySites?: IGenericObject[];
    listDemandSites?: IGenericObject[];

}

export class LookupState implements ILookupState {
	isPageRendered?: boolean;
	service?: LookupServices;
	searchParam?: {};
	listOfDemandPurposes?: CommonObjectModel[];
	listOfDemandStatus?: CommonObjectModel[];
	listOfCommonGoals?: CommonObjectModel[];
  	listOfCommonManagers?: CommonObjectModel[];
  	listOfMonth?: IGenericObject[];
	listOfAddressTitles?: CommonObjectModel[];
	listOfC21Professions?: CommonObjectModel[];
	listOfCategories?: CommonObjectModel[];
	listOfDepartments?: CommonObjectModel[];
	listOfDurationTasks?: CommonObjectModel[];
	listOfCities?: CommonObjectModel[];
	listOfCities1?: CommonObjectModel[];
	listOfCities2?: CommonObjectModel[];
	listOfCities3?: CommonObjectModel[];
	listOfCountries?: CommonObjectModel[];
	listOfCountries1?: CommonObjectModel[];
	listOfCountries2?: CommonObjectModel[];
	listOfCountries3?: CommonObjectModel[];
	listOfGoals?: IGenericObject[];
	listOfLetterTitles?: CommonObjectModel[];
	listOfMaritalStatuses?: CommonObjectModel[];
	listOfPersonDemands?: CommonObjectModel[];
	listOfPersonFunctions?: CommonObjectModel[];
	listOfPersonProperties?: CommonObjectModel[];
	listOfPersonProposals?: CommonObjectModel[];
	listOfPersonSources?: CommonObjectModel[];
	listOfPersonTypes?: CommonObjectModel[];
	listOfPhoneDescriptions?: CommonObjectModel[];
	listOfPreConfirmations?: CommonObjectModel[];
	listOfPreferredMedia?: CommonObjectModel[];
	listOfPurposes?: IGenericObject[];
	listOfRelationTypes?: CommonObjectModel[];
	listOfRelationReverseTypes?: CommonObjectModel[];
	listOfStatus?: IGenericObject[];
	listOfStatuses?: IGenericObject[];
	listOfSites?: IGenericObject[];
	listOfSinceDate?: IGenericObject[];
	listOfTaskTypes?: CommonObjectModel[];
	listOfTaskGroups?: CommonObjectModel[];
	listTypesOfProperty?: IGenericObject[];
	listOfDocumentTypes?: IGenericObject[];
	listOfDocumentPublish?: IGenericObject[];
	listOfPictureGroups?: IGenericObject[];

	listOfRoomStates?: IGenericObject[];
	listOfRoomDescriptions?: IGenericObject[];
	listOfRoomCovering?: IGenericObject[];
	listOfRoomFloors?: IGenericObject[];
	listOfRoomKeywords?: IGenericObject[];
	listOfOrientations?: IGenericObject[];
	listOfHasSummon?:IGenericObject[];

	listOfCO2Emission?: IGenericObject[];
	listOfInsulation?: IGenericObject[];
	listOfEPCLuxembourg?: IGenericObject[];
	listOfEPCFlanders?: IGenericObject[];
	listOfEPCImmoWeb?: IGenericObject[];
	listOfEPCType?: IGenericObject[];
	listOfEPCNR?: IGenericObject[];
	listOfEPCkNR?: IGenericObject[];
	listOfEPCBrussels?: IGenericObject[];
	listOfGroundCertificate?: IGenericObject[];
	listOfOilTankPlacement?: IGenericObject[];
	listOfOilTankFurtherExploitation?: IGenericObject[];
	listOfOilTankCertificateOfInspection?: IGenericObject[];
	listOfElectricityImmoWeb?: IGenericObject[];
	listOfGasolineImmoWeb?: IGenericObject[];

	listOfPermitOptions?: IGenericObject[];
	listOfAreaApplication?: IGenericObject[];
	listOfHeritageType?: IGenericObject[];
	listOfFloodRisk?: IGenericObject[];
	listOfFloodZoneType?: IGenericObject[];
	listOfYesNo?: IGenericObject[];
	listOfAsbestosType?: IGenericObject[];
	listOfEmailByPropertyIds?: PropertyEmailLookupModelDto[];
	listOfCompanies?: IGenericObject[];
	listOfManWoman?: IGenericObject[];
	listOfViagerType?: IGenericObject[];
	listOfRegisteredTypeFlanders?: IGenericObject[];
	listOfRegisteredTypeWallonia?: IGenericObject[];
	listOfRegisteredTypeBrussels?: IGenericObject[];
	listOfRegisteredTypeNone?: IGenericObject[];
	listOfPublicUtilities?: IGenericObject[];
	listOfChargeElements?: IGenericObject[];
	listOfPropertyEnvironment?: ILookupPropertyEnvironment[];

	//
	listOfCondition?: ICondition[]
	listOfConstruction?: IConstruction[]
	listOfExteriorComfort?: IExteriorComfort[]
	listOfGoal?: IGoal[]
	listOfHeating?: IHeating[]
	listOfHeatingB?: IHeatingB[]
	listOfInteriorComfort?: IInteriorComfort[]
	listOfKitchen?: IKitchen[]
	listOfRearOrientation?: IRearOrientation[]
	listOfRoofMaterial?: IRoofMaterial[]
	listOfRoof?: IRoof[]
	listOfStyle?: IStyle[]
	listOfRoofCondition?: IRoofCondition[]
	listOfWindowsGlazing?: IWindowsGlazing[]
	listOfWindowFrame?: IWindowFrame[]
	listOfSourceContact?: ISourceContact[]
	listOfCanceledReason?: ISourceContact[]
	//#region property-relation

	listOfMandateType?: IGenericObject[];
	listOfProlongationType?: IGenericObject[];
	listOfCommissionType?: IGenericObject[];
	listOfDepositType?: IGenericObject[];
	listOfPersonType?: IGenericObject[];
	listOfConfirmEmailTime?: IGenericObject[];
	listOfParticularConditionClause?: IGenericObject[];
	listOfPrePaymentType?: IGenericObject[];
	listOfImmoWebOption?: CommonObjectModel[];
	ListOfPublishOnMedia?: CommonObjectModel[];
	ListOfFinanceReduction?: CommonObjectModel[];
	//#endregion


	//#region WE CAN STORE EVERYTHING IN ONE OBJECT
    storedlookupObject?: Object;
    storedlookupColor?: Object;
	//#endregion

	listOfAppointmentTypes?: IAppointmentTypeListing[];
	listOfAppointmentStatus?: IAppointmentStatus[];
	listOfPersonalByAgendaId?: any[];
    listOfCandidates?: any[];
    listPersonSites?: IGenericObject[];
    listPropertySites?: IGenericObject[];
    listDemandSites?: IGenericObject[];

	/**
	 *
	 */
	constructor(options: ILookupState) {
		this.storedlookupObject = this.storedlookupObject || {};
        this.storedlookupColor = this.storedlookupColor || {};

		this.isPageRendered = options.isPageRendered;
		this.service = options.service;
		this.searchParam = options.searchParam;


		this.listOfAddressTitles = null;
		this.listOfC21Professions = null;
		this.listOfCategories = null;
		this.listOfDepartments = null;
		this.listOfDurationTasks = null;
		this.listOfCities = null;
		this.listOfCities1 = null;
		this.listOfCities2 = null;
		this.listOfCities3 = null;
		this.listOfCountries = null;
		this.listOfCountries1 = null;
		this.listOfCountries2 = null;
		this.listOfCountries3 = null;
		this.listOfGoals = null;
		this.listOfLetterTitles = null;
		this.listOfMaritalStatuses = null;
		this.listOfPersonDemands = null;
		this.listOfPersonFunctions = null;
		this.listOfPersonProperties = null;
		this.listOfPersonProposals = null;
		this.listOfPersonSources = null;
		this.listOfPhoneDescriptions = null;
		this.listOfPreConfirmations = null;
		this.listOfPreferredMedia = null;
		this.listOfPurposes = null;
		this.listOfRelationTypes = null;
		this.listOfRelationReverseTypes = null;
		this.listOfStatus = null;
		this.listOfStatuses = null;
		this.listOfSites = null;
		this.listOfSinceDate = null;
		this.listOfTaskTypes = null;
		this.listOfTaskGroups = null;
		this.listTypesOfProperty = null;
		this.listOfDocumentTypes = null;
		this.listOfDocumentPublish = null;
		this.listOfPictureGroups = null;
		this.listOfRoomStates = null;
		this.listOfRoomDescriptions = null;
		this.listOfRoomCovering = null;
		this.listOfRoomFloors = null;
		this.listOfRoomKeywords = null;
    	this.listOfOrientations = null;
    
    	this.listOfCO2Emission = null;
    	this.listOfInsulation = null;
    	this.listOfEPCLuxembourg = null;
		this.listOfEPCBrussels = null;
		this.listOfEPCFlanders = null;
		this.listOfEPCImmoWeb = null;
		this.listOfEPCType = null;
		this.listOfEPCNR = null;
		this.listOfEPCkNR = null;
		this.listOfGroundCertificate = null;
		this.listOfOilTankPlacement = null;
		this.listOfOilTankFurtherExploitation = null;
		this.listOfOilTankCertificateOfInspection = null;
		this.listOfElectricityImmoWeb = null;
		this.listOfGasolineImmoWeb = null;
		this.listOfPermitOptions = null;
		this.listOfAreaApplication = null;
		this.listOfHeritageType = null;
		this.listOfFloodRisk = null;
		this.listOfFloodZoneType = null;
		this.listOfYesNo = null;
		this.listOfAsbestosType = null;
		this.listOfPersonTypes = null;
		this.listOfEmailByPropertyIds = null;
		this.listOfCompanies = null;
		this.listOfManWoman = null;
		this.listOfViagerType = null;
		this.listOfRegisteredTypeFlanders = null;
		this.listOfRegisteredTypeWallonia = null;
		this.listOfRegisteredTypeBrussels = null;
		this.listOfRegisteredTypeNone = null;
		this.listOfChargeElements = null;
		this.listOfPublicUtilities = null;
		this.listOfHasSummon = null;
    	this.listOfMonth = null;
		this.listOfCommonManagers = null;
		this.listOfCommonGoals = null;
		this.listOfDemandStatus = null;
		this.listOfDemandPurposes = null;
		this.listOfPropertyEnvironment = null;
		//
		this.listOfCondition = null;
		this.listOfConstruction = null;
		this.listOfExteriorComfort = null;
		this.listOfGoal = null;
		this.listOfHeating = null;
		this.listOfHeatingB = null;
		this.listOfInteriorComfort = null;
		this.listOfKitchen = null;
		this.listOfRearOrientation = null;
		this.listOfRoofMaterial = null;
		this.listOfRoof = null;
		this.listOfStyle = null;
		this.listOfRoofCondition = null;
		this.listOfWindowsGlazing = null;
		this.listOfWindowFrame = null;
		this.listOfImmoWebOption = null;

		//#region property-relation
		this.listOfMandateType = null;
		this.listOfProlongationType = null;
		this.listOfCommissionType = null;
		this.listOfDepositType = null;
		this.listOfPersonType = null;
		this.listOfConfirmEmailTime = null;
		this.listOfParticularConditionClause = null;
		this.listOfPrePaymentType = null;
		this.listOfSourceContact = null;
		this.listOfCanceledReason = null;
		//#endregion

		this.listOfAppointmentTypes = [];
		this.listOfAppointmentStatus = [];
		this.ListOfFinanceReduction = null;
		this.listOfPersonalByAgendaId = [];
        this.listOfCandidates = [];
        this.listPersonSites = [];
        this.listPropertySites = [];
        this.listDemandSites = [];
	}
}
